import "./FeedbackForm.css";
import { useState } from "react";
import { CreatePostDTO } from "../../types/CreatePostDTO";

interface Props {
  onSubmit: (data: CreatePostDTO) => void;
  createdById: number;
}

function FeedbackForm({ onSubmit, createdById }: Props) {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [impact, setImpact] = useState("Low");

  const [errors, setErrors] = useState({
    title: "",
    description: "",
  });

  const validate = () => {
    const newErrors = {
      title: "",
      description: "",
    };

    if (title.trim().length < 5) {
      newErrors.title = "Bitte gib mindestens 5 Zeichen für den Titel ein.";
    }

    if (description.trim().length < 3) {
      newErrors.description = "Bitte gib mindestens 3 Zeichen für die Beschreibung ein.";
    }

    setErrors(newErrors);

    return !newErrors.title && !newErrors.description;
  };

  const handleSubmit = () => {
    if (createdById === 0) return;

    const isValid = validate();
    if (!isValid) return;

    onSubmit({
      title,
      description,
      impact,
      createdById,
    });

    setTitle("");
    setDescription("");
    setImpact("Low");
    setErrors({ title: "", description: "" });
  };

  return (
    <div className="feedback-form">
      <h2 className="feedback-title">Feedback erstellen</h2>

      <div className="feedback-form-group">
        <label>Titel</label>
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="feedback-input"
        />
        {errors.title && <span className="error-text">{errors.title}</span>}
      </div>

      <div className="feedback-form-group">
        <label>Beschreibung</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="feedback-textarea"
        />
        {errors.description && <span className="error-text">{errors.description}</span>}
      </div>

      <div className="feedback-form-group">
        <label>Impact</label>
        <select
          value={impact}
          onChange={(e) => setImpact(e.target.value)}
          className="feedback-input"
        >
          <option value="Low">Tief</option>
          <option value="Medium">Mittel</option>
          <option value="High">Hoch</option>
        </select>
      </div>

      <button onClick={handleSubmit} className="feedback-create-button">
        Feedback Erstellen
      </button>
    </div>
  );
}

export default FeedbackForm;
